import { useNavigate } from 'react-router-dom';
import ArrowBack from '@mui/icons-material/ArrowBack';
import { Body, ButtonStyled, Container, Content, InformationContainer, Text, Title } from '@/pages/NotFound/styled';
import { WarningSvg } from '@/svgs';

const NotFound = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else navigate('/', { replace: true });
  };

  return (
    <Body>
      <Container>
        <Content>
          <WarningSvg width={160} height={160} />

          <InformationContainer role="alert">
            <Title>Not Found</Title>
            <div>
              <Text>Either you typed a wrong URL, or you followed a bad link.</Text>
            </div>
          </InformationContainer>

          <ButtonStyled onClick={handleGoBack} startIcon={<ArrowBack />}>
            Go Back
          </ButtonStyled>
        </Content>
      </Container>
    </Body>
  );
};

export default NotFound;
